import axios from 'axios'

const STORAGE_TOKEN = 'TOKEN'
const STORAGE_DEVICE_ID = 'device-uuid'

function getToken(): string {
  return localStorage.getItem(STORAGE_TOKEN) || ''
}

function getDeviceId(): string {
  return localStorage.getItem(STORAGE_DEVICE_ID) || ''
}

function getBrowserLanguage(): string {
  const lang = navigator.language || 'en'
  // 映射到接口需要的语言码
  const map: Record<string, string> = {
    'en': 'en',
    'zh-TW': 'zh-hant',
    'ja': 'ja',
    'ko': 'ko',
    'fr': 'fr',
    'de': 'de',
    'es': 'es',
    'id': 'id',
  }
  return map[lang] || map[lang.split('-')[0]] || 'en'
}

function createTraceId(): string {
  const random = Math.floor(Math.random() * 900000 + 100000)
  const env = import.meta.env.MODE?.includes('production') ? 'p' : 't'
  return `${env}_rocnovel_pc_${Date.now()}_${random}`
}

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE || '/story-api',
  responseType: 'json',
  timeout: 15000,
})

// 请求拦截：注入所有必要请求头（对齐 H5 api.ts）
api.interceptors.request.use((config) => {
  config.headers.Platform = 3
  config.headers.versionCode = '110'
  config.headers.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  config.headers.xy_trace_id = createTraceId()
  config.headers.clientGroupName = 'Rocnovel'
  config.headers.contentType = '4'
  config.headers.language = getBrowserLanguage()

  // 开发环境直连 API 服务器，跳过 Vite 代理（对齐 H5 api.ts 同名逻辑，避免 CORS/nginx 二次代理问题）
  if (import.meta.env.MODE === 'development')
    config.baseURL = 'https://story-api-test.rocnovel.com'

  const token = getToken()
  if (token)
    config.headers.Authorization = token

  const equipmentId = getDeviceId()
  if (equipmentId)
    config.headers.equipmentId = equipmentId

  return config
})

// 响应拦截：返回 response.data；code !== 0 视为业务错误
api.interceptors.response.use(
  (response) => {
    if (response.data.code === 401) {
      localStorage.removeItem(STORAGE_TOKEN)
      window.location.replace('/')
      return Promise.reject(response.data)
    }
    if (response.data.code !== 0)
      return Promise.reject(response.data)
    return response.data
  },
  error => Promise.reject(error),
)
